import { Box, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

interface DataState {
  length: number;
  alphanumeric: string;
  size: number;
  delimiter: string;
  prefix: string;
}

export default function ConnectedClients() {
  const alphanumericOptions = [
    { value: "true", label: "True" },
    { value: "false", label: "False" },
  ];
  const [tokenFormat, setTokenFormat] = useState<DataState>({
    length: 6,
    alphanumeric: "false",
    size: 3,
    delimiter: " ",
    prefix: "",
  });

  const onChange = useCallback(
    (e) => {
      const { name, value } = e.target;

      if (name === "length") {
        if (value < 0 || value > 50) {
          setTokenFormat({ ...tokenFormat, [name]: 6 });
          return;
        }
      }
      if (name === "size") {
        if (value < 0 || value > tokenFormat.length - 1) {
          setTokenFormat({ ...tokenFormat, [name]: 3 });
          return;
        }
      }

      setTokenFormat({ ...tokenFormat, [name]: value });
    },
    [tokenFormat]
  );

  return (
    <Box
      className="container__card"
      sx={{ boxShadow: 2, margin: "20px 0px", marginBottom: "60px" }}
    >
      <Typography variant="h4" component="h4">
        Token Format
      </Typography>
      <TextField
        label="Length"
        variant="outlined"
        type="number"
        className="register__input"
        required
        name="length"
        onChange={onChange}
        value={tokenFormat.length}
        helperText="Please enter the length of the token (min 1, max 50)"
        InputProps={{
          inputProps: {
            max: 50,
            min: 1,
          },
        }}
      />
      <TextField
        select
        className="register__input"
        label="Alphanumeric"
        defaultValue="false"
        helperText="Please select if the token should be alphanumeric or not"
        variant="outlined"
        onChange={onChange}
      >
        {alphanumericOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label="Size"
        variant="outlined"
        type="number"
        className="register__input"
        required
        name="size"
        onChange={onChange}
        value={tokenFormat.size}
        helperText="Please enter the size of the token (min 1, max length - 1)"
        InputProps={{
          inputProps: {
            max: tokenFormat.length - 1,
            min: 1,
          },
        }}
      />
      <TextField
        label="Delimiter"
        variant="outlined"
        type="text"
        className="register__input"
        required
        name="delimiter"
        onChange={onChange}
        value={tokenFormat.delimiter}
        helperText="Please enter the delimiter of the token, by default it is empty space"
        inputProps={{ maxLength: 1, minLength: 1 }}
      />
      <TextField
        label="Prefix"
        variant="outlined"
        type="text"
        className="register__input"
        required
        name="prefix"
        onChange={onChange}
        value={tokenFormat.prefix}
        helperText="Please enter the prefix of the token (min 0, max 5 characters)"
        inputProps={{ maxLength: 5, minLength: 0 }}
      />
    </Box>
  );
}
